import mutations from './mutations'
import * as actions from './actions'
import * as getters from './getters'

const initialState ={
    deliveryNotes: [],
    deliveryNoteTemplateId: 1,
    selectAllField: false,
    selectedDeliveryNotes: [],
    totalDeliveryNotes: 0,
    selectedCustomer: null,

    deliveryNoteItems: [],
    selectAllFieldItem: false,
    selectedDeliveryNoteItems: [],
    availableDeliveryNoteItems:[],
    deliveryNoteItemsStatus: false,
    POHasItems:false
}

export default{

    namespaced : true,

    state : initialState,

    actions : actions,

    getters : getters,

    mutations : mutations
}